module.exports = __webpack_public_path__ + "static/assets/45db05db82b565cf2b8384b33235de83.png";